<template>
<section class="hero newsroom-hero is-hidden-mobile is-hidden-tablet-only is-hidden-desktop-only">
        <div class="hero-body">
            <section class="section">
                <div class="container">
                    <div class="columns">
                        <div class="column is-8">
                        <div class="deposit-products-box">
                            <p class="title hero-title">
                                Newsroom
                            </p>
                            <p class="subtitle hero-subtitle">
                                Get the latest news about WebBank, our partners and the products we offer right here.
                            </p>
                        </div>
                    </div>
                    </div>

                </div>
            </section>
        </div>
    </section>

    <div class="blue-bg is-hidden-widescreen">
                        <img src="https://assets.webbank.com/newsroom-hero.png">
        <section class="section">
            <div class="container">
                            <p class="title hero-title-mobile">
                                Newsroom
                            </p>
                            <br>
            </div>
        </section>
    </div>

    <section class="section grey-bg">
        <div class="container">

<div class="tile is-ancestor">
  <div class="tile is-vertical">
    <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child card">
                            <router-link to="/newsroom/webbank-PR34-2023-10-02">
                                <div class="card-image">
                                  <figure class="image">
                                    <img src="https://assets.webbank.com/newsroom/pr34-small.png" alt="Collective Liquidity and Aliya Capital">
                                  </figure>
                                </div>
                                <div class="card-content">
                                  <div class="media">
                                    <div class="media-content">
                                      <p class="press-release">Press Release</p>
                                      <p class="title is-4">Collective Liquidity Closes Financing Round and Partners with Aliya Capital Partners</p>
                                      <br>
                                      <br>
                                    <time datetime="2023-10-02" class="news-date">October 2nd, 2023</time>
                                    </div>
                                  </div>
                                </div>
                            </router-link>
                  </article>
                </div>
                <div class="tile is-parent">
                  <article class="tile is-child card">
                            <router-link to="/newsroom/webbank-PR33-2023-09-12">
                                <div class="card-image">
                                  <figure class="image">
                                    <img src="https://assets.webbank.com/newsroom/pr33-small.png" alt="Zip Primer Partnership">
                                  </figure>
                                </div>
                                <div class="card-content">
                                  <div class="media">
                                    <div class="media-content">
                                      <p class="press-release">Press Release</p>
                                      <p class="title is-4">Zip Partners with Global Payments Leader Primer to Accelerate U.S. Growth and Market Share</p>
                                      <br>
                                      <br>
                                    <time datetime="2023-09-12" class="news-date">September 12th, 2023</time>
                                    </div>
                                  </div>
                                </div>
                            </router-link>
                  </article>
                </div>
                <div class="tile is-parent">
                  <article class="tile is-child card">
                            <router-link to="/newsroom/webbank-PR31-2023-07-26">
                                <div class="card-image">
                                  <figure class="image">
                                    <img src="https://assets.webbank.com/newsroom/pr31-small.png" alt="Financial Technology Association">
                                  </figure>
                                </div>
                                <div class="card-content">
                                  <div class="media">
                                    <div class="media-content">
                                      <p class="press-release">Press Release</p>
                                      <p class="title is-4">WebBank Joins the Financial Technology Association</p>
                                      <br>
                                      <br>
                                    <time datetime="2023-07-25" class="news-date">July 25th, 2023</time>
                                    </div>
                                  </div>
                                </div>
                            </router-link>
                  </article>
                </div>
    </div>
  </div>
</div>

<div class="tile is-ancestor">
  <div class="tile is-vertical">
    <div class="tile">
              <div class="tile is-parent">
                <article class="tile is-child card">
                          <router-link to="/newsroom/webbank-PR32-2023-07-26">
                              <div class="card-image">
                                <figure class="image">
                                  <img src="https://assets.webbank.com/newsroom/pr32-small.png" alt="Financial Technology Association">
                                </figure>
                              </div>
                              <div class="card-content">
                                <div class="media">
                                  <div class="media-content">
                                    <p class="press-release">Press Release</p>
                                    <p class="title is-4">WEBBANK ANNOUNCES JASON LLOYD’S APPOINTMENT TO THE UTAH
                                        BANKERS ASSOCIATION BOARD OF DIRECTORS</p>
                                    <br>
                                    <br>
                                  <time datetime="2023-07-25" class="news-date">July 25th, 2023</time>
                                  </div>
                                </div>
                              </div>
                          </router-link>
                </article>
              </div>
              <div class="tile is-parent">
                <article class="tile is-child card">
                          <router-link to="/newsroom/webbank-PR30-2023-06-11">
                              <div class="card-image">
                                <figure class="image">
                                  <img src="https://assets.webbank.com/newsroom/pr30-small.png" alt="WebBank Honored">
                                </figure>
                              </div>
                              <div class="card-content">
                                <div class="media">
                                  <div class="media-content">
                                    <p class="press-release">Press Release</p>
                                    <p class="title is-4">WebBank Honored as One of the Best Places to Work in Financial Technology 2023</p>
                                    <br>
                                    <br>
                                  <time datetime="2023-06-11" class="news-date">June 11th, 2023</time>
                                  </div>
                                </div>
                              </div>
                          </router-link>
                </article>
              </div>
            <div class="tile is-parent">
              <article class="tile is-child card">
                        <router-link to="/newsroom/build-PR29-2023-05-23">
                            <div class="card-image">
                              <figure class="image">
                                <img src="https://assets.webbank.com/newsroom/pr29_small.png" alt="PROG Holdings Announces Build">
                              </figure>
                            </div>
                            <div class="card-content">
                              <div class="media">
                                <div class="media-content">
                                  <p class="press-release">Press Release</p>
                                  <p class="title is-4">PROG Holdings Announces Build, an
                                        Innovative Credit Building Financial
                                        Management Tool</p>
                                  <br>
                                  <br>
                                <time datetime="2023-05-23" class="news-date">May 23rd, 2023</time>
                                </div>
                              </div>
                            </div>
                        </router-link>
              </article>
            </div>
    </div>
  </div>
</div>

<div class="tile is-ancestor">
  <div class="tile is-vertical">
    <div class="tile">
            <div class="tile is-parent">
              <article class="tile is-child card">
                        <router-link to="/newsroom/lane-health-apex-PR28-2023-05-22">
                            <div class="card-image">
                              <figure class="image">
                                <img src="https://assets.webbank.com/newsroom/pr28_small.png" alt="Lane Health APEX Award">
                              </figure>
                            </div>
                            <div class="card-content">
                              <div class="media">
                                <div class="media-content">
                                  <p class="press-release">Press Release</p>
                                  <p class="title is-4">Lane Health Extends Streak of Industry Recognition with Third
                                                  Consecutive APEX Award</p>
                                  <br>
                                  <br>
                                <time datetime="2023-05-22" class="news-date">May 22nd, 2023</time>
                                </div>
                              </div>
                            </div>
                        </router-link>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child card">
                        <router-link to="/newsroom/petal-raise-PR27-2023-05-18">
                            <div class="card-image">
                              <figure class="image">
                                <img src="https://assets.webbank.com/newsroom/pr27_small.png" alt="Petal Raises $35 Million">
                              </figure>
                            </div>
                            <div class="card-content">
                              <div class="media">
                                <div class="media-content">
                                  <p class="press-release">Press Release</p>
                                  <p class="title is-4">Petal Raises $35 Million in New Funding, Spins Off B2B Data Analytics Unit Prism Data</p>
                                  <br>
                                  <br>
                                <time datetime="2023-05-02" class="news-date">May 10th, 2023</time>
                                </div>
                              </div>
                            </div>
                        </router-link>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child card">
                        <router-link to="/newsroom/onemain-financial-PR26-2023-05-16">
                            <div class="card-image">
                              <figure class="image">
                                <img src="https://assets.webbank.com/newsroom/pr26_small.png" alt="OneMain Financial">
                              </figure>
                            </div>
                            <div class="card-content">
                              <div class="media">
                                <div class="media-content">
                                  <p class="press-release">Press Release</p>
                                  <p class="title is-4">OneMain Financial Partners with FinMkt to Offer Access to Point of Sale Home
                                      Improvement Loans</p>
                                  <br>
                                  <br>
                                <time datetime="2023-05-02" class="news-date">May 2nd, 2023</time>
                                </div>
                              </div>
                            </div>
                        </router-link>
              </article>
            </div>
    </div>
  </div>
</div>
<!-- comment to invalidate cache... delete me -->

<div class="tile is-ancestor">
  <div class="tile is-vertical">
    <div class="tile">
              <div class="tile is-parent">
                <article class="tile is-child card">
                          <router-link to="/newsroom/can-capital-PR25-2023-04-24">
                              <div class="card-image">
                                <figure class="image">
                                  <img src="https://assets.webbank.com/newsroom/pr25_small.png" alt="CAN Capital">
                                </figure>
                              </div>
                              <div class="card-content">
                                <div class="media">
                                  <div class="media-content">
                                    <p class="press-release">Press Release</p>
                                    <p class="title is-4">CAN Capital Reaches Impressive Milestone, Providing Access to Over
                                      $8 Billion in Working Capital to U.S. Businesses</p>
                                    <br>
                                    <br>
                                  <time datetime="2022-12-07" class="news-date">April 5th, 2023</time>
                                  </div>
                                </div>
                              </div>
                          </router-link>
                </article>
              </div>
              <div class="tile is-parent">
                <article class="tile is-child card">
                          <router-link to="/newsroom/libertas-funding-PR23-2023-03-31">
                              <div class="card-image">
                                <figure class="image">
                                  <img src="https://assets.webbank.com/newsroom/pr23_small.png" alt="Libertas Funding">
                                </figure>
                              </div>
                              <div class="card-content">
                                <div class="media">
                                  <div class="media-content">
                                    <p class="press-release">Press Release</p>
                                    <p class="title is-4">Libertas Eclipses $2 Billion Funding Volume Milestone</p>
                                    <br>
                                    <br>
                                  <time datetime="2022-12-07" class="news-date">March 27th, 2023</time>
                                  </div>
                                </div>
                              </div>
                          </router-link>
                </article>
              </div>
            <div class="tile is-parent">
              <article class="tile is-child card">
                        <router-link to="/newsroom/glassdoor-PR22-2023-01-27">
                            <div class="card-image">
                              <figure class="image">
                                <img src="https://assets.webbank.com/newsroom/pr22-small2.png" alt="Eraj Asadi">
                              </figure>
                            </div>
                            <div class="card-content">
                              <div class="media">
                                <div class="media-content">
                                  <p class="press-release">Press Release</p>
                                  <p class="title is-4">WebBank Announces Eraj Asadi Named SVP - Head of Asset Finance</p>
                                  <br>
                                  <br>
                                <time datetime="2022-12-07" class="news-date">January 25th, 2023</time>
                                </div>
                              </div>
                            </div>
                        </router-link>
              </article>
            </div>
    </div>
  </div>
</div>

<div class="tile is-ancestor">
  <div class="tile is-vertical">
    <div class="tile">
              <div class="tile is-parent">
                <article class="tile is-child card">
                          <router-link to="/newsroom/glassdoor-PR21-2023-01-20">
                              <div class="card-image">
                                <figure class="image">
                                  <img src="https://assets.webbank.com/newsroom/pr21-small.png" alt="Glassdoor">
                                </figure>
                              </div>
                              <div class="card-content">
                                <div class="media">
                                  <div class="media-content">
                                    <p class="press-release">Press Release</p>
                                    <p class="title is-4">WebBank Honored as One of the Best Places to Work in 2023</p>
                                    <br>
                                    <br>
                                  <time datetime="2022-12-07" class="news-date">January 20th, 2023</time>
                                  </div>
                                </div>
                              </div>
                          </router-link>
                </article>
              </div>
              <div class="tile is-parent">
                <article class="tile is-child card">
                          <router-link to="/newsroom/kelsey-hardy-PR20-2023-01-20">
                              <div class="card-image">
                                <figure class="image">
                                  <img src="https://assets.webbank.com/newsroom/pr20-small.png" alt="Kelsey Hardy Promotion">
                                </figure>
                              </div>
                              <div class="card-content">
                                <div class="media">
                                  <div class="media-content">
                                    <p class="press-release">Press Release</p>
                                    <p class="title is-4">WebBank Announces Kelsey Hardy Named SVP - Business Development</p>
                                    <br>
                                    <br>
                                  <time datetime="2022-12-07" class="news-date">January 20th, 2023</time>
                                  </div>
                                </div>
                              </div>
                          </router-link>
                </article>
              </div>
            <div class="tile is-parent">
              <article class="tile is-child card">
                        <router-link to="/newsroom/avant-funding-PR19-2022-12-07">
                            <div class="card-image">
                              <figure class="image">
                                <img src="https://assets.webbank.com/newsroom/pr19-small.png" alt="Avant Secures Funding">
                              </figure>
                            </div>
                            <div class="card-content">
                              <div class="media">
                                <div class="media-content">
                                  <p class="press-release">Press Release</p>
                                  <p class="title is-4">Avant Secures $250 Million In Funding From Ares Management Corporation</p>
                                  <br>
                                  <br>
                                <time datetime="2022-12-07" class="news-date">December 7th, 2022</time>
                                </div>
                              </div>
                            </div>
                        </router-link>
              </article>
            </div>
    </div>
  </div>
</div>

            <newsroom-pagination></newsroom-pagination>


        </div>
    </section>

</template>

<script>
import NewsroomPagination from './Components/NewsroomPagination.vue';
export default {
    components: { NewsroomPagination },

    created() {
        document.title = "Newsroom - WebBank";
    },

}
</script>
